import { DownloadOutlined, FunnelPlotFilled, LoadingOutlined, ShareAltOutlined } from '@ant-design/icons'
import { useLockedOrders } from '@hooks/useLockedOrders'
import { GraviButton, Texto, Horizontal } from '@gravitate-js/excalibrr'
import { useUserSettings } from '@hooks/settings'
import { Col, Popconfirm, Row, Steps } from 'antd'
import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { useOrderContainersContext } from '../Contexts/OrderContainersContext'
import { useWizardMaster } from '../Contexts/WizardMasterContext'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
const { Step } = Steps

export function OrderSteps({ order, closeModal }) {
  const [popConfirmVisible, setPopConfirmVisible] = useState(false)
  const { scopes } = useSecurityContext()
  const canAccessOMPage = useMemo(() => !!scopes?.order_movements_page, [scopes])
  const { trailerOverride } = useOrderContainersContext()
  const { updateSetting } = useUserSettings()
  const { lockedOrders } = useLockedOrders()
  const optimizing = useMemo(() => lockedOrders?.map((o) => o.order_id).includes(order?.id), [lockedOrders, order])
  if (!order) return null
  const loads = order.loads || order.load_plan
  const drops = order.drops || order.drop_plan
  const stopCount = drops.length + loads.length
  const {
    isEditingBackhaul,
    isBackhaul,
    driverNote,
    setDriverNote,
    isSaving,
    saveOrder,
    saveBackhaul,
    wizardOrder,
    isOrderChanged,
    setIsOrderChanged,
  } = useWizardMaster()
  const confirm = () => {
    setDriverNote(undefined)
    setPopConfirmVisible(false)
    setIsOrderChanged(false)
    closeModal()
  }

  const cancel = () => {
    setPopConfirmVisible(false)
  }

  const handleVisibleChange = (visible) => {
    if (!visible) {
      setPopConfirmVisible(visible)
      return
    }
    if (!isEditingBackhaul) {
      setIsOrderChanged(false)
      closeModal() // next step
    } else {
      setPopConfirmVisible(true)
    }
  }
  return (
    <Row className='order-status p-3'>
      <Col className='vertical-flex-center' span={6}>
        {' '}
        {wizardOrder ? (
          <Horizontal gap={16}>
            {canAccessOMPage && (
              <Link
                target='_blank'
                to={`/order_movements_page/report?${new URLSearchParams({ order_number: wizardOrder.number })}`}
                onClick={() => {
                  localStorage.setItem('current-order-movements-report-view', 'all')
                  updateSetting('current-order-movements-report-view', 'all')
                }}
              >
                <GraviButton icon={<ShareAltOutlined />} buttonText='View Movement' />
              </Link>
            )}
          </Horizontal>
        ) : (
          <Texto category='h5'>Order: N/A</Texto>
        )}
      </Col>
      <Col className='pt-1' style={{ display: 'flex', alignItems: 'center' }} span={14}>
        <Steps current={stopCount}>
          {loads.map((load, index) => (
            <Step
              className='load-step'
              key={`load_${index}`}
              icon={<FunnelPlotFilled style={{ color: 'var(--theme-color-2)' }} />}
              title={load.location_name}
            />
          ))}
          {drops.map((drop, index) => (
            <Step
              key={`drop_${index}`}
              className='drop-step'
              icon={<DownloadOutlined style={{ color: 'var(--theme-color-3)' }} />}
              title={drop.location_name}
            />
          ))}
        </Steps>
      </Col>
      <Col span={4}>
        <Row>
          <Col span={24} align='right'>
            <Popconfirm
              title='You have unsaved changes, are you sure you want to close?'
              open={popConfirmVisible}
              onOpenChange={handleVisibleChange}
              onConfirm={confirm}
              onCancel={cancel}
              okText='Yes'
              cancelText='No'
            >
              <GraviButton className='mr-3' buttonText='Close' appearance='outline' data-cy='close-order-modal-btn' />
            </Popconfirm>
            {isOrderChanged && (
              <GraviButton
                theme2
                className='mr-3'
                buttonText='Save Order'
                disabled={isSaving || optimizing}
                icon={isSaving && <LoadingOutlined spin />}
                onClick={() => {
                  isBackhaul
                    ? saveBackhaul({ closeModal })
                    : saveOrder({ closeModal, resendToCarrier: false, trailerOverride })
                }}
              />
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}
